import { CreateOfferBody, Offer, UpdateOfferBody } from '@core/models/offer.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class OfferService {
    private readonly addOfferURL = `/offer/add`;
    private readonly updateOfferURL = `/offer/update`;
    private readonly deleteOfferURL = `/offer/delete`;
    private readonly getAllOffersURL = `/offer/get-all`;
    private readonly getOfferByIdURL = `/offer/get`;

    // ---------------------------------------------------------------

    addOffer(body: CreateOfferBody) {
        return fetchWithRetry(API.post(this.addOfferURL, body));
    }

    updateOffer(id: number, body: { numberOfStatic: string }) {
        return fetchWithRetry(API.patch(`${this.updateOfferURL}/${id}`, body));
    }

    deleteOffer(id: number) {
        return fetchWithRetry(API.delete(`${this.deleteOfferURL}/${id}`));
    }

    getAllOffers() {
        return fetchWithRetry(API.get<Offer[]>(this.getAllOffersURL));
    }

    getOfferById(id: number) {
        return fetchWithRetry(API.get<Offer>(`${this.getOfferByIdURL}/${id}`));
    }
}

export default new OfferService();
